angular.module('theme').directive('validZipcode', function($q, $cookies, ZipCodeService) {

	function checkZipCode(zipCode) {
		if (!zipCode) {
			return $q.reject('Not valid zipcode');
		}

		return ZipCodeService.check(zipCode).then(function (response) {
			if (response.zipcodeStatus !== 1) {
				return $q.reject(response.zipcodeMessage);
			}

			return response.zipcodeMessage;
		});
	}

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			ngModel.$asyncValidators.zipcode = checkZipCode;
		}
	};
});
